import {Language} from "../../../../types/dto/Language";


interface Period {
    startDate: number;
    endDate: number;
    value?: string;
}

interface LocalizedValuePeriod extends Period{ 
    language: Language
}

enum MileStoneType{
    OPRICHTING = "oprichting",
    STOPZETTING = "stopzetting",
    OPENING_FAILLISSEMENT = "opening-faillissement",
    SLUITING_FAILLISSEMENT = "sluiting-faillissement",
    INTREKKING_FAILLISSEMENT = "intrekking-faillissement"
}

interface MileStone extends TimelineEvent{
    type: MileStoneType;
    info: string;
}

interface TimelineEvent {
    date: number;
}

interface PeriodList {
    name: string;
    link: string;
    type: "person" | "company"
    periods: Period[]
}

export {
    TimelineEvent,
    MileStone,
    MileStoneType,
    Period,
    LocalizedValuePeriod,
    PeriodList
}